import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
export const withRouter = WrappedComponent => props => {

    return (<WrappedComponent {...props} navigate={useNavigate()} params={useParams()} search={useSearchParams()}/>);
};